export const environment = {
  name: 'dev',
  apiUrl: 'https://sfmb-api-dev.azure.chevron.com/api',
  clientId: 'fab19ea5-238d-4a37-9b3c-ac1d06cfa574',
  tenantId: 'fd799da1-bfc1-4234-a91c-72b3a1cb9e26',
};